import dayjs from "dayjs"

// Shared overlap predicate for calendar-conflict checks. Originally lived only inside
// worker_checkCalendarConflicts.ts (inbox background worker); pulled out here so the same
// logic can be reused synchronously on the main thread (detail Game Plan rows, compose-time
// SuggestWhenModalNd warning) without importing the worker module itself (which assigns
// self.onmessage/self.onerror at module scope -- fine inside a Worker, but pollutes
// window.onmessage if imported into the main bundle).
export const getCurrentEventRange = (event: any) => {
  const start = dayjs(
    event?.startDate || event?.start?.dateTime || event?.start
  )
  const end = dayjs(event?.endDate || event?.end?.dateTime || event?.end)

  return { start, end }
}

export const checkIfEventsConflict = (firstEvent: any, secondEvent: any) => {
  const range1 = getCurrentEventRange(firstEvent)
  const range2 = getCurrentEventRange(secondEvent)

  return range1.start.isBefore(range2.end) && range2.start.isBefore(range1.end)
}
